import React, { useContext } from "react";
import Backdrop from "@material-ui/core/Backdrop";
import { makeStyles } from "@material-ui/core/styles";
import { useHistory } from "react-router-dom";
import { LayoutContext } from "./wrappers/withLayout";
import { URI_PATHS } from "../../constants";

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: 10,
    backgroundColor: "#e7eaef73",
  },
}));

const Loading = ({ showBackdrop }) => {
  const classes = useStyles();
  const history = useHistory();
  const { navWidth } = useContext(LayoutContext);
  const fromMockDashboard = history.location.pathname === URI_PATHS.PREAPPROVAL_DASHBOARD;

  return (
    <div className="inset-0 fixed flex justify-center items-center z-50">
      {showBackdrop && (
        <Backdrop className={classes.backdrop} open={showBackdrop} />
      )}
      <div className="loader" style={{ marginLeft: fromMockDashboard ? navWidth : 0 }} />
    </div>
  );
};

export default Loading;